import React, { PropsWithChildren, useContext, useEffect } from 'react';
import { RouterContext, RouterDispatchContext } from '../context/routing';
import { LoadingPage } from '../components/shared';

const Router: React.FC<PropsWithChildren> = ({ children }) => {
  const { init, routingMap } = useContext(RouterContext);
  const setRouter: $TSFixMe = useContext(RouterDispatchContext);

  useEffect(() => {
    setRouter({
      routingMap,
      roles: ['authenticated', 'citizen'],
      init: true,
    });
  }, [routingMap, setRouter]);

  if (!init) return <LoadingPage />;

  return <>{children}</>;
};

export default Router;
